'use client';

var s = {"textArea":"CheckBoxTextarea-module_textArea__2nGbq","totalText":"CheckBoxTextarea-module_totalText__3nHV0","label":"CheckBoxTextarea-module_label__2ZM7u"};

export { s as default };
//# sourceMappingURL=CheckBoxTextarea.module.scss.js.map
